import api from "../api";

export const createReservedSchedule = (companyUrl, schedule) => {
  const params = new URLSearchParams({ companyUrl }).toString();
  return api.post(
    `/reserved-schedule?${params}`, 
    schedule, 
        { 
            withAuth: true,
            headers: {
            "Content-Type": "application/json",
            },
        }   
    );
};

export const createReservedScheduleByOwner = (companyUrl, schedule) => {
  const params = new URLSearchParams({ companyUrl }).toString();
  return api.post(
    `/reserved-schedule?${params}`, 
    schedule, 
        { 
            withAuth: true,
            headers: {
            "Content-Type": "application/json",
            },
        }   
    );
};

export const updateSchedule = (companyUrl, schedule) => {
  const params = new URLSearchParams({ companyUrl }).toString();
  return api.put(
    `/reserved-schedule?${params}`,
    schedule,
        {
            withAuth: true,
            headers: {
                "Content-Type": "application/json",
            },
        }  
    );
};

export const removeReservedSchedule = (companyUrl, schedule) => {
  const params = new URLSearchParams({ companyUrl }).toString();

  return api.delete(
    `/reserved-schedule?${params}`,
    {
      data: schedule,
      withAuth: true,
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

// professionalId: de quem é o agendamento (com mais de um profissional, horários podem coincidir)
export const removeReservedScheduleByOwner = (companyUrl, schedule, onlyUncheck, professionalId) => {
  const params = new URLSearchParams({ companyUrl }).toString();

  return api.delete(
    `/reserved-schedule/owner?${params}`,
    {
      data: { schedule, onlyUncheck, professionalId },
      withAuth: true,
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};